import React, {  useState } from 'react';
import {
  AiFillFacebook,
  AiFillLinkedin,
  AiOutlineInstagram,
  AiOutlineTwitter,
} from 'react-icons/ai';
import { ContactUs } from '../Home/ContactUs';
import YoutubeEmbed from '../../components/YoutubeEmbed';

export const Description = () => {
  const [activeAboutPage,setActiveAboutPage] = useState("about");
   return ( <>
      <div
        id='header'
        className='relative w-12/12 flex flex-row w-full'
      >
        {activeAboutPage === 'about' && <img src='/walter&donnie.svg' style={{width:'100%',height:''}} alt='konzortia' />}
        {activeAboutPage === 'mission' && <img src='/rocket.svg' alt="rocket" />}
        {activeAboutPage === 'members' && <img src='/membersHero.svg' alt="hero" />}
      </div>
      <div className='px-4  mx-auto container w-12/12 bg-white '>
        {activeAboutPage === 'about' && (
          <div className='flex flex-col lg:flex-row '>
            <div className='lg:w-8/12 w-12/12 leading-loose py-12 px-12 flex flex-col content-left justify-left text-left'>
              <span className='font-primary font-size-22 text-black font-bold py-4'>
                About Konzortia Capital
              </span>
              <span className='font-primary font-size-16 text-black '>
                Konzortia Capital is a next-generation FinTech holding company revolutionizing private capital markets through a suite of integrated platforms powered by artificial intelligence, machine learning, and blockchain technology. Anchored by its flagship solution, Alpha Hub, Konzortia Capital simplifies and accelerates every stage of the investment lifecycle—from intelligent deal sourcing and capital raising to due diligence, pipeline management, and transaction execution. With a unique &quot;Source–Match–Exit&quot; model, Konzortia Capital addresses the fragmentation and inefficiencies in private markets by offering real-time data insights, secure blockchain infrastructure, and liquidity tools through its additional platforms: Alpha Markets, Alpha Blocks, and Alpha Terminal. Designed for venture capital, private equity, family offices, and startups, Konzortia Capital empowers stakeholders to make smarter, faster, and more transparent investment decisions across a $13+ trillion global market.
              </span>
              <span className='font-primary font-size-22 text-black font-bold py-4'>
                Solutions for Efficiency in Private Capital Markets
              </span>
              <span className='font-primary font-size-16 text-black '>
                The Private Capital Markets experience significant challenges and some inefficiencies with their operations. There is fierce competition and a race to secure the best deals, traditional networking and deal sourcing which may not necessarily identify all of the best investment opportunities, as well as a shortage of staff to plow through data rooms and extensive due diligence processes. Konzortia’s AI / ML monitors and analyzes millions of data points while scoring projects to match investors’ criteria with the companies that are best suited according to historical investment behavior. 
                <br/><br/>
                The objective is to enhance efficiency, gain speed to market, improve profitability and upside potential, and achieve success for both funders and founders.
              </span>
              <span className='font-primary font-size-22 text-black font-bold py-4'>
                Alternative Investments
              </span>
              <span className='font-primary font-size-16 text-black '>
                The alternative markets provide portfolio diversification and proven better potential returns on average than traditional markets. With the record levels of dry powder ready to be allocated, Alpha Hub can accelerate the investment placement process and help founders through the different stages of the capitalization life cycle. 
                <br/><br/>
                We screen, score and curate projects to improve the probability of success!
              </span>
              <span className='font-primary font-size-22 text-black font-bold py-4'>
                Explore Konzortia Capital’s FinTech Platforms for Private Market Innovation
              </span>
              <span className='font-primary font-size-16 text-black '>
                At Konzortia Capital, we are redefining the private capital landscape through a suite of next-generation FinTech platforms designed to streamline and optimize every stage of the investment lifecycle. Our integrated ecosystem includes <b>Alpha Hub</b> for intelligent deal sourcing and capital raising, <b>Alpha Markets</b> for unlocking liquidity through secondary transactions, <b>Alpha Blocks</b> for blockchain-enabled security and transparency, and <b>Alpha Terminal</b> for data-driven investment intelligence. Together, these platforms empower investors and capital-raising companies with the tools they need to move faster, make smarter decisions, and gain a competitive edge in today’s dynamic private markets.
              </span>
              <span className='font-primary font-size-22 text-black font-bold py-4'>
                Alpha Hub<br/><i>An Integrated Platform for Smarter Investing</i>
              </span>
              <span className='font-primary font-size-16 text-black '>
                Alpha Hub is transforming the private capital ecosystem. By combining deal sourcing, capital raising, data analysis, due diligence, and pipeline management into one seamless platform, it connects startups and early-stage companies with a network of qualified investors. Leveraging AI and ML, Alpha Hub enhances matching accuracy, automates investment workflows, and accelerates success for both sides of the deal. (Alpha Hub)
              </span>
              <span className='font-primary font-size-22 text-black font-bold py-4'>
                Alpha Markets<br/><i>Unlocking Liquidity & Expanding Access</i>
              </span>
              <span className='font-primary font-size-16 text-black '>
                Alpha Markets is being developed to provide innovative market solutions that support trading, secondary transactions, and broader market access for private investments. Our tools will help investors improve portfolio liquidity, navigate complex market dynamics, and identify unique opportunities in a typically opaque marketplace. (More details coming soon.)
              </span>
              <span className='font-primary font-size-22 text-black font-bold py-4'>
                Alpha Blocks<br/><i>Blockchain-Driven Security & Transparency</i>
              </span>
              <span className='font-primary font-size-16 text-black '>
                Alpha Blocks leverages blockchain technology to improve security, transparency, and operational efficiency in private capital markets. With a focus on smart contracts and decentralized record-keeping, our blockchain solutions will reduce transaction costs, mitigate fraud risks, and enhance trust across all investment processes. (More information to be released soon.)
              </span>
              <span className='font-primary font-size-22 text-black font-bold py-4'>
                Alpha Terminal<br/><i>Data-Powered Investment Intelligence</i>
              </span>
              <span className='font-primary font-size-16 text-black '>
                Alpha Terminal delivers real-time market data, financial analysis, and trend insights to support better investment decisions. With customizable dashboards and predictive analytics, investors will gain a strategic advantage in evaluating opportunities, benchmarking deals, and managing risk. (Stay tuned for additional updates.)
              </span>
            </div>
            <div className='py-12 w-12/12 lg:w-4/12'>
              <div className='flex flex-col h-100'>
                <ContactUs />
                
                  
                <div className='w-full px-2 flex center-div'>
                  <iframe
                        src="https://player.vimeo.com/video/1113260116"
                        width="450"
                        height="350"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                        title="Vimeo Video"
                      ></iframe>
                </div>
                <div className='w-full px-2 flex center-div'>
                 <iframe
                      src="https://player.vimeo.com/video/1113210474"
                      width="450"
                      height="350"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                      title="Vimeo Video"
                    ></iframe>
              </div>
                
                <div className='px-4 py-4'>
                  <div className='bg-gray rounded py-2'>
                    <div
                      className='py-2 px-12 flex flex-row pointer'
                      onClick={() => setActiveAboutPage('mission')}
                    >
                      <img className='px-2' src='/linkIcon.svg' alt="konzortia" />
                      <span className='font-primary color-primary font-bold'>
                        Mission
                      </span>
                    </div>
                    <div
                      className='py-2 px-12 flex flex-row pointer'
                      onClick={() => setActiveAboutPage('members')}
                    >
                      <img className='px-2' src='/linkIcon.svg' alt="konzortia" />
                      <span className='font-primary color-primary font-bold'>
                        Meet the Konzortians
                      </span>
                    </div>
                    
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        )}
        {activeAboutPage === 'mission' && (
          <div className='flex flex-col lg:flex-row '>
            <div className='lg:w-8/12 w-12/12 leading-loose py-12 px-12 flex flex-col content-left justify-left text-left'>
              <span className='font-primary font-size-22 text-black font-bold py-4'>
                Mission
              </span>
              <span className='font-primary font-size-16 text-black '>
                Konzortia Capital was founded on a Dream to help Startup companies BLASTOFF and thrust through stages of capital raising, fueling their launch… while improving the success of investors, propelling their return on investment as it rockets skyward. 
                <br/><br/>
                Our multicultural and multi-faceted scientists, technicians and entire crew team of Konzortians will build the most dynamic and comprehensive platforms in this galaxy, shifting paradigms with state-of-the-art technology, innovating and constantly evolving so that our partners can save time, enhance efficiencies, and fly at the speed of light! 
                <br/><br/>
                Together we triumph as we TAKEOFF with exit velocity to never look back, leading the pack… taking YOU above and beyond.
              </span>
              
              <img src='/konzortiaBuildings.jpg' alt="konzortia" />
            </div>
            <div className='py-12 w-12/12 lg:w-4/12'>
              <div className='flex flex-col h-100'>
                <ContactUs />
                <div className='flex center-div flex-col'>
                  <div className='py-2 pt-4'>
                    <iframe
                      src="https://player.vimeo.com/video/1113265108"
                      width="300"
                      height="250"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                      title="Vimeo Video"
                    ></iframe>
                  </div>
                </div>
                
                <div className='px-4 py-4'>
                  <div className='bg-gray rounded py-2'>
                    <div
                      className='py-2 px-12 flex flex-row pointer'
                      onClick={() => setActiveAboutPage('mission')}
                    >
                      <img className='px-2' src='/linkIcon.svg' alt="konzortia" />
                      <span className='font-primary color-primary font-bold'>
                        Mission
                      </span>
                    </div>
                    <div
                      className='py-2 px-12 flex flex-row pointer'
                      onClick={() => setActiveAboutPage('members')}
                    >
                      <img className='px-2' src='/linkIcon.svg' alt="konzortia" />
                      <span className='font-primary color-primary font-bold'>
                        Meet the Konzortians
                      </span>
                    </div>
                    
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        )}
        {activeAboutPage === 'members' && (
          <div className='flex flex-col lg:flex-row '>
            <div className='lg:w-8/12 
            w-12/12 leading-loose py-12 px-12 flex flex-col content-left justify-left text-left'>
              <img src='/membersTitle.svg' className='pb-12' alt="konzortia" />
              <div className='flex flex-col'>
                <div className='flex flex-row'>
                  <img
                    src='/walterGomezAvatar.svg' alt="founder"
                    className='py-4 pointer lg:px-4 lg:w-56 lg:h-56 h-36 w-36'
                    onClick={() =>
                      (window.open(
                        'https://www.linkedin.com/in/thefounder2020/'))
                    }
                  />
                  <img
                    src='/donnieGomezAvatar.svg' alt="cofounder"
                    className='py-4 pointer lg:px-4 lg:w-56 lg:h-56 h-36 w-36'
                    onClick={() =>
                      (window.open(
                        'https://www.linkedin.com/in/donnie-gomez-b52492197'))
                    }
                  />
                  <img
                    src='/alRomeroAvatar.svg' alt="cfo"
                    className='py-4 lg:px-4 lg:w-56 cursor-pointer lg:h-56 h-36 w-36'
                    onClick={() =>
                      (window.open(
                        'https://www.linkedin.com/in/tom-krutilek/'))
                    }
                  />
                </div>
                <div className='flex flex-row'>
                <img src='/aisha.svg' className='py-4 lg:px-4 pointer lg:w-56 lg:h-56 h-36 w-36' alt="co"   onClick={() =>
                        (window.open(
                          'https://www.linkedin.com/in/aisha-el-merhebi-717b0328'))
                      }/>
                    <img
                      src='/ally.svg' alt="chief_of_staff"
                      className='py-4 pointer lg:px-4 lg:w-56 lg:h-56 h-36 w-36'
                      onClick={() =>
                        (window.open(
                          'https://www.linkedin.com/in/ally-stevens-shrm-cp-88069186/'))
                      }
                    />
                   
                </div>
                
              </div>
            </div>
            <div className='py-12 w-12/12 lg:w-4/12'>
              <div className='flex flex-col h-100'>
                <ContactUs />
                <div className='flex center-div flex-col'>
                  <div className='py-2 pt-4'>
                    <div className='flex center-div flex-col'>
                  <div className='py-2 pt-4'>
                    <iframe
                      src="https://player.vimeo.com/video/1113265108"
                      width="300"
                      height="250"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                      title="Vimeo Video"
                    ></iframe>
                  </div>
                </div>
                  </div>
                </div>
                <div className='px-4 py-4'>
                  <div className='bg-gray rounded py-2'>
                    <div
                      className='py-2 px-12 flex flex-row pointer'
                      onClick={() => setActiveAboutPage('mission')}
                    >
                      <img className='px-2' src='/linkIcon.svg' alt='konzortia' />
                      <span className='font-primary color-primary font-bold'>
                        Mission
                      </span>
                    </div>
                    <div
                      className='py-2 px-12 flex flex-row pointer'
                      onClick={() => setActiveAboutPage('members')}
                    >
                      <img className='px-2' src='/linkIcon.svg' alt='konzortia' />
                      <span className='font-primary color-primary font-bold'>
                        Meet the Konzortians
                      </span>
                    </div>
                    
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        )}
      </div>
    </>
   );
};
